"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var selectDealerButtonStyles = styles_1.makeStyles(function (theme) { return ({
    buttonLabel: {
        height: 34,
        width: 120,
        borderRadius: 0,
        fontWeight: 300,
        textTransform: 'uppercase',
        '& span': {
            fontSize: theme.typography.fontXS,
        },
        '&:disabled': {
            color: theme.palette.common.white,
        },
    },
    isSelected: {
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.primary.main,
        },
        '&:focus': {
            backgroundColor: theme.palette.primary.main + "!important",
        },
        color: theme.palette.common.white,
    },
    newOutlinedPrimary: {},
}); }, { name: 'Checkout_SelectDealerButton' });
exports.default = selectDealerButtonStyles;
